import { Box, Typography } from "@mui/material";
import { StatusChip } from "../../../shared/components";
import { LowPriority, PriorityHigh } from "@mui/icons-material";

export const headers = [
    { "alias_name": "project_id", "label": "Query ID & Details", "display_order": 1, is_show: true },
    { "alias_name": "category_display_text", "label": "Type", "display_order": 2, is_show: true },
    { "alias_name": "priority", "label": "Priority", "display_order": 3, is_show: true },
    { "alias_name": "status", "label": "Status", "display_order": 4, is_show: true },
    { "alias_name": "assigned_to", "label": "Assigned to", "display_order": 6, is_show: true },
    { "alias_name": "raised_by", "label": "Raised By", "display_order": 7, is_show: true },
    { "alias_name": "submitted_date", "label": "Date submitted", "display_order": 8, is_show: true },
    { "alias_name": "sla_date", "label": "SLA Date", "display_order": 9, is_show: true },
    { "alias_name": "title", "label": "", "display_order": 10, is_show: false },
    { "alias_name": "description", "label": "", "display_order": 11, is_show: false },
];

export const metrics = {
    "project_id": {
        type: "component",
        element: (row: { title: string, description: string, query_reference_number: string }) => (
            <Box display={'flex'} alignItems={'start'} flexDirection={'column'}>
                <Typography variant="caption" color="text.secondary">{row.query_reference_number}</Typography>
                <Typography variant="body2" color="text.primary">{row.title}</Typography>
                <Typography variant="caption" color="text.secondary">{row.description}</Typography>
            </Box>
        )
    },
    "category_display_text": {
        type: "component",
        element: (row: { category_display_text: string }) => (
            <StatusChip label={row.category_display_text}
                sx={{ borderRadius: '4px' }}
                color={"default"} />
        )
    },
    "priority": {
        type: "component",
        element: (row: { priority: string }) => (
            <Typography
                variant="caption"
                sx={{
                    display: 'flex', alignItems: 'center',
                    color: (row.priority === 'High' || row.priority === 'Critical') ? 'error.main' : row.priority === 'Medium' ? 'warning.main' : 'success.main'
                }}
            >
                {row.priority === 'High' || row.priority === 'Medium' ? <PriorityHigh fontSize="small" /> : <LowPriority fontSize="small" />}
                {row.priority}
            </Typography>
        )
    },
    "status": {
        type: "component",
        element: (row: { status: string }) => (
            <StatusChip label={row.status} color={row.status === "Open" ? "amber" : "green"} />
        )
    },
    "submitted_date": {
        type: "date",
    },
    "sla_date": {
        type: "date",
    },
    "assigned_to": {
        type: "component",
        element: (row: { assigned_to: string }) => {
            return (
                <Box display="flex" alignItems="center" gap={1}>
                    {/* Circle DP */}
                    <Box
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: "50%",
                            bgcolor: "divider",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "success.contrastText",
                            fontSize: "0.8rem",
                            fontWeight: 600,
                            textTransform: "uppercase",
                        }}
                    >
                        {row?.assigned_to.split(" ").filter(Boolean).map(word => word[0].toUpperCase()).join("").slice(0, 2)}
                    </Box>

                    {/* Full Name */}
                    <Typography variant="caption" color="text.primary">
                        {row.assigned_to}
                    </Typography>
                </Box>
            );
        }
    },
    "raised_by": {
        type: "component",
        element: (row: { raised_by: string }) => {
            return (
                <Box display="flex" alignItems="center" gap={1}>
                    {/* Circle DP */}
                    <Box
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: "50%",
                            bgcolor: "divider",      // Or generate random color
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "success.contrastText",
                            fontSize: "0.8rem",
                            fontWeight: 600,
                            textTransform: "uppercase",
                        }}
                    >
                        {row?.raised_by.split(" ").filter(Boolean).map(word => word[0].toUpperCase()).join("").slice(0, 2)}
                    </Box>

                    {/* Full Name */}
                    <Typography variant="caption" color="text.primary">
                        {row.raised_by}
                    </Typography>
                </Box>
            );
        }
    }
};